import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import * as Actions from 'app/store/actions';
import { buildGoogleAuthorizationUrl, isGoogleOAuthConfigured, storeGoogleOAuthState } from '../googleOAuth';

function GoogleLoginButton() {
    const dispatch = useDispatch();

    function handleGoogleLogin() {
        if (!isGoogleOAuthConfigured()) {
            dispatch(
                Actions.showMessage({
                    message: 'Faltan REACT_APP_GOOGLE_CLIENT_ID o REACT_APP_GOOGLE_REDIRECT_URI en el .env',
                    autoHideDuration: 6000,
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    },
                    variant: 'error'
                })
            );
            return;
        }

        const state = storeGoogleOAuthState();
        window.location.assign(buildGoogleAuthorizationUrl(state));
    }

    return (
        <Button
            type="button"
            variant="outlined"
            color="default"
            className="w-full mx-auto mt-16 normal-case"
            onClick={handleGoogleLogin}
        >
            Ingresar con SomosEtica
        </Button>
    );
}

export default GoogleLoginButton;
